// Footer.js
import { connect } from 'react-redux';

import {
  SUPPORTED_LANGUAGES,
  SWAG_CAREERS,
  SWAG_BLOG,
  SWAG_SELECT,
  SWAG_HELP_CENTER,
  TIKTOK_URL,
  YOUTUBE_URL,
  DISCORD_URL,
  INSTAGRAM_URL,
  TWITTER_URL,
  TELEGRAM_URL,
  AFFILIATE_PROGRAM_URL,
  BUSINESS_COOPERATION_EMAIL,
  DMCA_ID,
} from '../RemoteConfigKeys.js';

import Footer from '../component/Footer.jsx';
import withRouter from '../component/WithRouter.jsx';

import updateLanguage from '../action/updateLanguage.js';
import toggleModal from '../action/toggleModal.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getModalData from '../selector/getModalData.js';

const mapStateToProps = state => {
  return {
    supportedLanguages: getRemoteConfigData(state, SUPPORTED_LANGUAGES),
    swagCareersUrl: getRemoteConfigData(state, SWAG_CAREERS),
    swagBlogUrl: getRemoteConfigData(state, SWAG_BLOG),
    swagSelectUrl: getRemoteConfigData(state, SWAG_SELECT),
    swagHelpCenterUrl: getRemoteConfigData(state, SWAG_HELP_CENTER),
    tiktokUrl: getRemoteConfigData(state, TIKTOK_URL),
    youtubeUrl: getRemoteConfigData(state, YOUTUBE_URL),
    discordUrl: getRemoteConfigData(state, DISCORD_URL),
    instagramUrl: getRemoteConfigData(state, INSTAGRAM_URL),
    twitterUrl: getRemoteConfigData(state, TWITTER_URL),
    telegramUrl: getRemoteConfigData(state, TELEGRAM_URL),
    affiliateProgramUrl: getRemoteConfigData(state, AFFILIATE_PROGRAM_URL),
    businessCooperationUrl: getRemoteConfigData(
      state,
      BUSINESS_COOPERATION_EMAIL
    ),
    dmcaId: getRemoteConfigData(state, DMCA_ID),
    isDebugOpened: ['opening', 'display'].includes(
      getModalData(state, 'DebugPanelModal', 'status')
    ),
    isProfileAboutSwagOpened: ['opening', 'display'].includes(
      getModalData(state, 'ProfileAboutSwag', 'status')
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateLanguage: ({ language }) => dispatch(updateLanguage({ language })),
    toggleModal: payload => dispatch(toggleModal(payload)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer));
